export default "__VITE_ASSET__CM3PUQ8E__"